import React, { Component } from 'react';
import { path } from 'ramda';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import config from '../generated/config';
import Input from '../commons/component/input';
import InputNumber from '../commons/component/input-number';
import Button from '../commons/component/button';
import Svg from '../commons/component/svg';
import Error, { hasNamedError } from '../commons/component/error';
import { moveToLoginToShoppingClubFlux } from '../commons/query';
import Eye from '../icons/eye-svg';
import { logout, isCustomerAuthenticated } from '../api/customer/login';
import { associateShoppingClub } from '../api/shopping-club/association';
import UserIcon from '../icons/user-icon';
import Checkbox from '../commons/component/checkbox';

class LoginAssociadoComponent extends Component {
  state = {
    cpf: '',
    password: '',
    showPassword: false,
    isFormSubmitting: false,
    isShoppingClubAssociatedSuccessfully: false,
    acceptedTerms: false,
    errors: {}
  };

  componentWillMount() {
    if (!isCustomerAuthenticated()) {
      return this.returnToLogin();
    }
  }

  render() {
    if (this.state.isShoppingClubAssociatedSuccessfully) {
      return (
        <div id="results">
          <div className="cadastroForm-container">
            <h2 className="cadastroForm-title">
              <UserIcon />
              <span>Identificação do associado</span>
            </h2>

            <div className="alert alert-success">
              <div className="alert-status">
                <Svg name="icon-alert-success" className="svg-icon svg-icon-sm" />
              </div>
              <div className="alert-content">
                <p>Sua requisição foi efetuada com sucesso.</p>
              </div>
            </div>

            <Button
              primary
              onClick={() => {
                window.location = `${path(['url', 'home'], config)}`;
              }}
              className="cadastroForm-submit"
            >
              Retornar a página inicial
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="cadastroForm-container">
        <h2 className="cadastroForm-title">
          <UserIcon />
          <span>Identificação do associado</span>
        </h2>
        <form className="cadastroForm shoppingClub" onSubmit={this.associate.bind(this)}>
          <div className="inputGroup" id="cpf">
            <label className="inputGroup-label --acronym" htmlFor="cpf-input">
              CPF
            </label>
            <InputNumber
              name="cpf"
              id="cpf-input"
              data-page="signup"
              data-form="signup"
              onChange={this.changeField('cpf')}
              value={this.state.cpf}
              className={`inputGroup-input ${this.hasError('cpf')}`}
              maxLength="11"
              type="text"
              mask="___.___.___-__"
              placeholder="Ex: 123.456.789-12"
            />
            <Error errors={this.state.errors} name="cpf" />
          </div>
          <div className="inputGroup" id="password">
            <label className="inputGroup-label" htmlFor="password">
              Senha
            </label>
            <Input
              name="password"
              id="password-input"
              data-form="signup"
              data-page="signup"
              type={this.state.showPassword ? 'text' : 'password'}
              onChange={this.changeField('password')}
              value={this.state.password}
              className={`inputGroup-input --withAddOn ${this.hasError('password')}`}
              autoComplete={false}
            />
            <span className="inputGroup-addOn" onClick={this.toggleShow('showPassword')}>
              <Eye on={!this.state.showPassword} />
            </span>
            <Error errors={this.state.errors} name="password" />
          </div>
          <div className="inputGroup" id="password">
            <p>Olá, verificamos que você é parte do time LASA/B2W/LETS/IF!</p>
            <p>Que bom ter você aqui :)</p>
            <p>
              Gostaríamos de lembrá-lo(a) que esse benefício é de uso pessoal e intransferível,
              exclusivo para associados, e por isso, não pode ser compartilhado com terceiros ou
              revendido, ok?
            </p>
            <p>
              Clicando no botão abaixo você confirma que tem ciência e concorda com as regras
              citadas. Agradecemos a compreensão!
            </p>
            <Checkbox
              className="inputGroup-checkbox"
              name="receiveWhatsApp"
              onChange={this.toggleShow('acceptedTerms')}
              checked={this.state.acceptedTerms}
              data-form="signup"
              data-page="signup"
            >
              Eu concordo com as regras citadas acima.
            </Checkbox>
          </div>
          <Button
            primary
            disabled={this.state.isFormSubmitting || !this.state.acceptedTerms}
            loading={this.state.isFormSubmitting}
            className="cadastroForm-submit"
          >
            Continuar
          </Button>
          <Error errors={this.state.errors} name="errorMessage" />
        </form>
      </div>
    );
  }

  async associate(evt) {
    evt.preventDefault();

    this.setState({ isFormSubmitting: true });
    const { cpf, password, acceptedTerms } = this.state;
    const { errors } = await associateShoppingClub({ cpf, password, acceptedTerms });

    if (errors) {
      this.setState({ errors, isFormSubmitting: false });
    } else {
      this.setState({ isShoppingClubAssociatedSuccessfully: true });
    }
  }

  changeField(name) {
    return e =>
      this.setState({
        ...this.state,
        [name]: e.target.value
      });
  }

  toggleShow(name) {
    return e =>
      this.setState({
        [name]: !this.state[name]
      });
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  returnToLogin() {
    logout();
    moveToLoginToShoppingClubFlux(this.props.history.push);
  }
}

class LoginAssociadoContainer extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path="/login-associado"
          children={() => <LoginAssociadoComponent history={this.props.history} />}
        />
        <Redirect to="/login-associado" />
      </Switch>
    );
  }
}

export default withRouter(LoginAssociadoContainer);
